'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('Alerts', ['$resource', '$http', 'apiSettings', function ($resource, $http, apiSettings) {

    var Alerts = $resource(apiSettings.baseUri + 'v1/alerts/:id', { id: '@id' }, {
        'list': {
            method: 'GET',
            isArray: false,
            params: {
                page: 1,
                pageSize: apiSettings.defaultPageSize
            }
        },
        'insertNew': {
            url:
                apiSettings.baseUri +
                "v1/alerts/new/:enumAlertType",
            method: 'POST',
            params: { id: '@enumAlertType' },
        },
        'count': {
            url: apiSettings.baseUri + 'v1/alerts/count',
            method: 'GET',
        },
        'read': {
            url: apiSettings.baseUri + 'v1/alerts/:alertGuid/read',
            params: { alertGuid: '@alertGuid' },
            method: 'PUT',
        },
        'readAll': {
            url: apiSettings.baseUri + 'v1/alerts/read',
            method: 'PUT',
        },
        'delete': {
            url: apiSettings.baseUri + 'v1/alerts/:alertGuid',
            params: { alertGuid: '@alertGuid' },
            method: 'DELETE'
        },
    });

    Alerts.notificationCount = 0;

    Alerts.updateCount = function () {
        return $http({
            method: 'GET',
            url: apiSettings.baseUri + 'v1/alerts/count'
        })
            .then(function (response) {
                Alerts.notificationCount = parseInt(response.data, 10);
                return Alerts.notificationCount;
            })
            .catch(function (error) {
                console.error("Erro ao obter a contagem:", error);
                throw error;
            });
    };

    return Alerts;
}]);
